import React from "react";
import {observer} from "mobx-react";
import {SearchMaskTripTypeComponent} from "./trip-type/search-mask-trip-type.component";
import styled from "styled-components";
import {StationsSelectorComponent} from "./stations-selector/stations-selector.component";
import {SearchButtonComponent} from "./search-button/search-button.component";
import {FlightDatesDropDownComponent} from "../flight-dates-drop-down/flight-dates-drop-down.component";
import {PassengersTypesDropDownComponent} from "../passengers-types-drop-down/passengers-types-drop-down.component";
import {SpecialPriceMarketComponent} from "./special-price-market/special-price-market.component";
import {VERTICAL_SPACING_PX} from "../css-global-constants";

export const SearchMaxBox = styled.div`
    display: flex;
    flex-direction: column;
    font-size: ${props => props.theme.fontSize.large};
    width: 100%;
    gap: ${VERTICAL_SPACING_PX}
`

export const SearchMaskComponent: React.FC = observer(() => {
    return (
        <SearchMaxBox>
            <SearchMaskTripTypeComponent/>
            <StationsSelectorComponent/>
            <SpecialPriceMarketComponent/>
            <FlightDatesDropDownComponent/>
            <PassengersTypesDropDownComponent/>
            <SearchButtonComponent/>
        </SearchMaxBox>
    );
})
